import * as Turbo from '@hotwired/turbo'
import { initAccountMenu } from '../lib/accountMenu'
import { initAnalyticsBeacon } from '../lib/analyticsBeacon'
import { initAppNav } from '../lib/appNav'
import { initAppScroll } from '../lib/appScroll'
import { initAppSearch } from '../lib/appSearch'
import { confirmModal } from '../lib/confirmModal'
import { initFinanceCover } from '../lib/financeCoverButton'
import { initNavNotifications } from '../lib/navNotifications'
import { initWriteWatch } from '../lib/writes'
import { initThemeSync } from '../lib/themeSync'

Turbo.config.forms.confirm = confirmModal

// Before anything else can write. Everything that keeps the screen honest
// after a save hangs off this: Turbo's cached pages are dropped, and mounted
// islands re-read their props. See lib/writes.ts.
initWriteWatch()

// The signed-in shell (the redesign) and the signed-out one (the marketing and
// auth pages, until slices 09 and 10 land) are both in the layout, and only one
// of them renders. Each of these no-ops when its own elements aren't there, so
// initialising both is how one build serves both — the nav* pair goes when the
// old shell does.
initAccountMenu()
initAppNav()
initAppScroll()
initAppSearch()
initFinanceCover()

initNavNotifications()
initThemeSync()
initAnalyticsBeacon()
